import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';
import { throwUnlessApiSuccess } from '../utils/apiResponse';

export const FETCH_SUPER_STOKEZES_REQUEST = 'FETCH_SUPER_STOKEZES_REQUEST';
export const FETCH_SUPER_STOKEZES_SUCCESS = 'FETCH_SUPER_STOKEZES_SUCCESS';
export const FETCH_SUPER_STOKEZES_FAILURE = 'FETCH_SUPER_STOKEZES_FAILURE';
export const CREATE_SUPER_STOKEZ_SUCCESS = 'CREATE_SUPER_STOKEZ_SUCCESS';
export const UPDATE_SUPER_STOKEZ_SUCCESS = 'UPDATE_SUPER_STOKEZ_SUCCESS';
export const DELETE_SUPER_STOKEZ_SUCCESS = 'DELETE_SUPER_STOKEZ_SUCCESS';
export const TOGGLE_LOCK_SUPER_STOKEZ_SUCCESS = 'TOGGLE_LOCK_SUPER_STOKEZ_SUCCESS';
export const TOGGLE_DELETE_SUPER_STOKEZ_SUCCESS = 'TOGGLE_DELETE_SUPER_STOKEZ_SUCCESS';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;


export const getSuperStokezes = () => async (dispatch) => {
  dispatch({ type: FETCH_SUPER_STOKEZES_REQUEST });
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const loggedInUsername = getLoggedInUsername();
    const response = await axios.post(`${base_url}`, {
      apiName: 'superStokez',
      command: 'getSuperStokezes',
      loggedInUserRole,
      loggedInUsername
    });
    dispatch({
      type: FETCH_SUPER_STOKEZES_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_SUPER_STOKEZES_FAILURE,
      payload: error.message || error.response?.data?.message || 'Failed to fetch super stokezes'
    });
  }
};

export const createSuperStokez = (superStokezData) => async (dispatch) => {
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const response = await axios.post(`${base_url}`, {
      apiName: 'superStokez',
      command: 'createSuperStokez',
      loggedInUserRole,
      ...superStokezData
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({
      type: CREATE_SUPER_STOKEZ_SUCCESS,
      payload: data
    });
    return response.data;
  } catch (error) {
    console.error('Failed to create super stokez:', error);
    throw error;
  }
};

export const updateSuperStokez = (superStokezId, updateData) => async (dispatch) => {
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const response = await axios.post(`${base_url}`, {
      apiName: 'superStokez',
      command: 'updateSuperStokez',
      superStokezId,
      updateData,
      loggedInUserRole,
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({
      type: UPDATE_SUPER_STOKEZ_SUCCESS,
      payload: data
    });
    return response.data;
  } catch (error) {
    console.error('Failed to update super stokez:', error);
    throw error;
  }
};

export const deleteSuperStokez = (superStokezId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'superStokez',
      command: 'toggleDeleteSuperStokez',
      superStokezId
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({
      type: TOGGLE_DELETE_SUPER_STOKEZ_SUCCESS,
      payload: data
    });
    return response.data;
  } catch (error) {
    console.error('Failed to delete super stokez:', error);
    throw error;
  }
};

export const toggleLockSuperStokez = (superStokezId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'superStokez',
      command: 'toggleLockSuperStokez',
      superStokezId
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({
      type: TOGGLE_LOCK_SUPER_STOKEZ_SUCCESS,
      payload: data
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
